module.exports = __webpack_public_path__ + "static/img/user5.28fc9e2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/v1/user5.png
// module id = cUx8
// module chunks = 0